import { Modal } from "@visiblethread/react-components";
import Ellipsis from "components/Ellipsis";
import Flex, { ALIGN_CLASS, DIRECTION_CLASS, GAP_CLASS } from "components/Flex";
import { modalTypes } from "constants/types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { selectArchivedOpportunitiesByReasonData } from "slices/archivedOpportunitiesByReason";
import { resolveCssVar } from "utils/cssVar";
import { toPercent } from "utils/toPercent";

import ArchivedOpportunitiesByReasonDonut from "../../ArchivedOpportunitiesByReason/ArchivedOpportunitiesByReasonDonut";
import { colorFor } from "../../ArchivedOpportunitiesByReason/constants";
import styles from "./ArchivedOpportunitiesByReasonModal.module.scss";

const MODAL_TITLE = "Archived Opportunities";

const ArchivedOpportunitiesByReasonModal = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectArchivedOpportunitiesByReasonData);

  const onDismiss = () => {
    dispatch(hideModal(modalTypes.ARCHIVED_OPPORTUNITIES_BY_REASON));
  };

  const totalArchivedCount = data?.totalArchivedCount ?? 0;
  const reasons = data?.reasons ?? [];

  return (
    <Modal
      backdrop
      centered
      className={`fade-in ${styles.modal}`}
      onDismiss={onDismiss}
      show
    >
      <Modal.Header>{MODAL_TITLE}</Modal.Header>
      <Modal.Body>
        <Flex
          direction={DIRECTION_CLASS.column}
          alignItems={ALIGN_CLASS.stretch}
          gap={GAP_CLASS.GAP_400}
          className={styles.archivedOpportunitiesByReasonModal}
        >
          <p className={styles.archivedOpportunitiesByReasonModal__subHeader}>
            {totalArchivedCount} archived · by archive reason
          </p>
          <Flex
            alignItems={ALIGN_CLASS.center}
            gap={GAP_CLASS.GAP_800}
            className={styles.archivedOpportunitiesByReasonModal__body}
          >
            <ArchivedOpportunitiesByReasonDonut
              reasons={reasons}
              totalArchivedCount={totalArchivedCount}
              wrapperClassName={styles.archivedOpportunitiesByReasonModal__donutWrapper}
            />
            <Flex
              as="ul"
              direction={DIRECTION_CLASS.column}
              gap={GAP_CLASS.GAP_150}
              aria-label="Archived opportunities by reason legend"
              className={styles.archivedOpportunitiesByReasonModal__legend}
            >
              {reasons.map((reason, index) => (
                <Flex
                  as="li"
                  key={reason.statusId}
                  alignItems={ALIGN_CLASS.center}
                  gap={GAP_CLASS.GAP_150}
                  className={styles.archivedOpportunitiesByReasonModal__legendRow}
                >
                  <span
                    aria-hidden="true"
                    className={styles.archivedOpportunitiesByReasonModal__legendSwatch}
                    style={{ background: resolveCssVar(colorFor(reason, index)) }}
                  />
                  <div className={styles.archivedOpportunitiesByReasonModal__legendName}>
                    <Ellipsis text={reason.statusName} />
                  </div>
                  <span className={styles.archivedOpportunitiesByReasonModal__legendCount}>
                    {reason.count} · {toPercent(reason.count, totalArchivedCount)}%
                  </span>
                </Flex>
              ))}
            </Flex>
          </Flex>
        </Flex>
      </Modal.Body>
    </Modal>
  );
};

export default ArchivedOpportunitiesByReasonModal;
